import { Translatable } from "@icc/shared/helpers";

export class RollerGuideChannelCap {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    width: number;
    img: null | string;
    order?: number;
    default?: boolean;
    length?: number | null;
    colorGroupSetId: number;
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;

    forMosquitoScreenChannel?: boolean;

    guideIds?: number[];
}

export interface IccRollerGuideChannelCap {
    id: number;
    extId: string;
    indexNo: string;
    name: string;
    width: number;
    img: null | string;
    order?: number;
    shutterTypes: number[];
    colorGroupSetId: number;
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;
    guideIds?: number[];

    forMosquitoScreenChannel?: boolean;
}
